import React from 'react';
import { Col } from 'react-bootstrap';
import DisplayUtils from '../../services/DisplayUtils';

const Colors = ({
  productInfo,
  variation,
  color,
  selectColor,
  deselectColor,
}) => {
  const dictionary = JSON.parse(productInfo.quantityDictionaryAsString) || [];
  const { media, colorsDictionary } = productInfo;

  return dictionary.colors.map((colorString) => {
    const colorHex = DisplayUtils.getColorHexCode(
      colorString,
      colorsDictionary,
    );
    const colorStyle = { backgroundColor: colorHex };

    let inStock = 0;
    if (variation === 'NONE') {
      inStock = dictionary[colorString].overallQuantity;
    } else {
      inStock = dictionary[colorString][variation];
    }

    if (color !== 'NONE' && colorString !== color) {
      colorStyle.opacity = 0.5;
      colorStyle.borderColor = '#E5E5E5';
      colorStyle.cursor = 'pointer';
    } else if (color === 'NONE') {
      colorStyle.cursor = 'pointer';
    } else if (inStock === 0) {
      colorStyle.cursor = 'default';
    } else {
      colorStyle.cursor = 'pointer';
    }

    if (inStock < 1 && !productInfo.isDropShip && !productInfo.isComposite) {
      return (
        <Col
          key={`color-item-${colorString}`}
          className='outOfStockColor'
          style={{ backgroundColor: colorHex }}
          lg={2}
        >
          <p style={{ visibility: 'hidden' }}>X</p>
        </Col>
      );
    }
    if (colorString === color) {
      return (
        <Col
          key={`color-item-${colorString}`}
          onClick={() => deselectColor()}
          style={colorStyle}
          lg={2}
        >
          <p style={{ visibility: 'hidden' }}>X</p>
        </Col>
      );
    }
    return (
      <Col
        key={`color-item-${colorString}`}
        onClick={() => selectColor(colorString, media)}
        style={colorStyle}
        lg={2}
      >
        <p style={{ visibility: 'hidden' }}>X</p>
      </Col>
    );
  });
};

export default Colors;
